import React, { useEffect } from 'react';
import { IonReactRouter } from '@ionic/react-router';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { useUserStore } from '../components/stateManagement/userZustand';
import Login from './Login';
import LandingPage from './LandingPage';
import { useGlobalStore } from '../components/stateManagement/globalZustand';
import ChooseLang from '../components/ChooseLang';
import AppRoot from './AppRoot';
import SuccessPage from '../components/Success';
import Logout from '../components/Logout';
import PrivacyPage from './Privacy';
import PricingPage from './PricingPage';
import ProblemReportPage from './ProblemReportPage';

const InitRouting: React.FC = () => {
    const { isSubscribed, hasLoggedIn, isUserStoreInitialized } = useUserStore();
    const { hasChosenLang, isGlobalStoreInitialized } = useGlobalStore();
    if(isUserStoreInitialized !== true || isGlobalStoreInitialized !== true ){ return <></> }
    if(hasChosenLang !== true){
        return <ChooseLang />;
    }

    if(isSubscribed === true){
        
        return <AppRoot />;
    }else{
        return (
                <IonReactRouter>
                    <Router>
                        <Switch>
                            <Route path="/success" exact={true}><SuccessPage /></Route>
                            <Route path="/logout" exact={true}><Logout /></Route>
                            <Route path="/privacy" exact={true}><PrivacyPage /></Route>
                            <Route path="/welcome" exact={true}><LandingPage /></Route>
                            <Route path="/lang" exact={true}><ChooseLang /></Route>
                            <Route path="/pricing" exact={true}><PricingPage /></Route>
                            <Route path="/login" exact={true}><Login /></Route>
                            <Route path="/report" exact={true}><ProblemReportPage /></Route>
                            <Route><Redirect to="/welcome" /></Route>
                        </Switch>
                    </Router>	
                </IonReactRouter>
        )
        
    }


};

export default InitRouting;